<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                landownerForm: () => import('../forms/LandownerForm'),
                memberForm: () => import('../forms/MemberForm'),
                fields: [
                    { type: 'autocomplete', text: 'Member', value: 'memberId', rules: [v => !!v || 'Member is required'], isRequired: true, form: () => import('./MemberForm'), apiMethod: 'Members', claim: 'Members' },
                    { type: 'text', text: 'Name', value: 'name', rules: [v => !!v || 'Name is required', v => !(v && v.length > 100) || 'Name must be less than 100 characters'], isRequired: true, maxLength: 100 },
                    { type: 'coordinates', text: 'Coordinates', value: 'coordinates', rules: [v => !!v || 'Coordinates is required'], isRequired: true },
                    { type: 'autocomplete', text: 'Landowner', value: 'landownerId', rules: [], form: () => import('./LandownerForm'), apiMethod: 'Landowners', claim: 'Landowners' },
                    { type: 'text', text: 'Nearest Town', value: 'nearestTown', rules: [v => !(v && v.length > 100) || 'Nearest Town must be less than 100 characters'], maxLength: 100 },
                    { type: 'text', text: 'Produce', value: 'produce', rules: [v => !(v && v.length > 100) || 'Produce must be less than 100 characters'], maxLength: 100 },
                    { type: 'checkbox', text: 'Is Near GMO', value: 'isNearGmo', rules: [v => (v !== null && v !== '') || 'Is Near GMO is required'], isRequired: true },
                    { type: 'checkbox', text: 'Is Farm', value: 'isFarm', rules: [v => (v !== null && v !== '') || 'Is Farm is required'], isRequired: true },
                    { type: 'checkbox', text: 'Requires Key To Access', value: 'requiresKeyToAccess', rules: [v => (v !== null && v !== '') || 'Requires Key To Access is required'], isRequired: true },
                    { type: 'checkbox', text: 'Must Contact Landowner To Access', value: 'mustContactLandownerToAccess', rules: [v => (v !== null && v !== '') || 'Must Contact Landowner To Access is required'], isRequired: true },
                    { type: 'textarea', text: 'Notes', value: 'notes', rules: [] },
                ],
                apiMethod: 'Sites',
                formTitle: 'Site',
            }
        },
    };
</script>
